export default "__VITE_ASSET__zjuEvOtx__"